import { LOGIN_USER_TYPE, USER_TYPE_STORAGE_KEY } from "constants/USER_TYPES";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { dataUsuarioVacio } from "../../constants";
import { dataUsuario } from "../../redux/actions/aLogin";

class ContainerLogout extends Component {
  componentDidMount = () => {
    localStorage.setItem("login", false);
    this.props.setDataUsuario(dataUsuarioVacio);
    const userType = localStorage.getItem(USER_TYPE_STORAGE_KEY);
    console.log(LOGIN_USER_TYPE[userType], userType);
    this.props.history.push({
      pathname: `/login?user=${LOGIN_USER_TYPE[userType]}`,
    });
  };

  render() {
    return <div>REDIRECCIONANDO</div>;
  }
}

const mapStateToProps = (state) => ({
  userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setDataUsuario: (data) => dispatch(dataUsuario(data)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContainerLogout));
